import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppButton from "../../components/AppButton";
import TextInput from "../../components/TextInput";
import { Formik } from "formik";
import { useHistory } from "react-router";

import "./auth.styles.css";
import { ForgotPasswordSchema } from "./ValidationSchema";
import Auth from "@aws-amplify/auth";

const PasswordRecoveryPage = () => {
  const history = useHistory();
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showVerifyCode, setShowVerifyCode] = useState(false);

  const initiateForgotPassword = async (email) => {
    setIsLoading(true);

    try {
      const result = await Auth.forgotPassword(email);

      setShowVerifyCode(true);
      setIsLoading(false);
      return result;
    } catch (error) {
      if (error.code === "LimitExceededException") {
        setErrorMessage(
          "You tried resetting your password too many times. Please try again later"
        );
      }
      console.log(
        "There was a problem initiating the forgot password request",
        error
      );
    }
  };

  const confirmForgotPassword = async ({
    email,
    confirmationCode,
    password,
  }) => {
    setIsLoading(true);

    try {
      const result = await Auth.forgotPasswordSubmit(
        email,
        confirmationCode,
        password
      );

      setIsLoading(false);

      return result;
    } catch (error) {
      console.log("There was a problem confirming the new password", error);
    }
  };

  return (
    <div className="auth__wrapper">
      <div className="auth__wrapper--left">
        <p>
          The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris num."
        </p>
        <span>Dave, Product manager.</span>
        <span className="staricon">
          <svg
            width="326"
            height="390"
            viewBox="0 0 326 390"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M186.372 36.3389C190.287 32.3472 193.947 28.1124 197.33 23.6595L196.011 43.322C190.535 124.956 225.007 204.546 288.459 256.777L323.227 285.396C221.606 267.515 122.842 326.997 91.6221 425.209L74.8061 478.108C59.1196 370.143 -30.1724 287.228 -139.004 279.951L-149.149 279.273C-55.7233 246.855 -2.70966 148.251 -27.119 51.4925L-39.4814 2.48749L-4.27459 37.1287C49.085 89.6308 134.44 89.2836 186.372 36.3389Z"
              stroke="#FBFBFB"
            />
          </svg>
        </span>
      </div>
      <div className="auth__wrapper--right w--full">
        <div className="auth__wrapper--rightMain">
          <h1 className="font--38">Recover your password</h1>

          <Formik
            validationSchema={ForgotPasswordSchema}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              email: "",
            }}
            onSubmit={async ({ email }) => {
              const result = await initiateForgotPassword(email);
              if (result) {
                setShowResetPassword(true);
              }
            }}
          >
            {({
              values,
              handleSubmit,
              handleChange,
              handleBlur,
              errors,
              touched,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="w--full mt--16">
                  <TextInput
                    name="email"
                    label="Email address"
                    placeholder="johnsmith@gmail.com"
                    type="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    withError={(errors.email && touched.email) || errorMessage}
                    errorMessage={
                      errors.email &&
                      touched.email &&
                      "Please enter your email address"
                    }
                    value={values.email}
                  />

                  {errorMessage && (
                    <div className="mt--16">
                      <p className="loginError">{errorMessage}</p>
                    </div>
                  )}
                </div>

                {showVerifyCode && (
                  <div className="mt--16">
                    <p className="verify-code-message">
                      A verification code has been sent to your email address,
                      please enter the code to proceed.
                    </p>
                  </div>
                )}

                {showResetPassword && (
                  <div className="w--full">
                    <div className="w--full mt--16">
                      <TextInput
                        name="confirmationCode"
                        type="text"
                        value={values.confirmationCode}
                        label="Confirmation code"
                        placeholder="Enter code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        withError={
                          errors.confirmationCode && touched.confirmationCode
                        }
                        errorMessage={
                          errors.confirmationCode &&
                          touched.confirmationCode &&
                          "Please enter your last name"
                        }
                      />
                    </div>
                    <div className="w--full mt--16">
                      <TextInput
                        label="Enter new password"
                        placeholder="*************"
                        type="password"
                        name="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        withError={errors.password && touched.password}
                        errorMessage={
                          errors.password &&
                          touched.password &&
                          "Create a strong password, add an uppercase letter and a number."
                        }
                      />
                    </div>
                  </div>
                )}

                {showResetPassword ? (
                  <div className="w--full">
                    <AppButton
                      title="Save new password"
                      styles={{ width: "100%", marginTop: 16 }}
                      type="button"
                      isLoading={isLoading}
                      onClick={async () => {
                        await confirmForgotPassword({
                          email: values.email,
                          confirmationCode: values.confirmationCode,
                          password: values.password,
                        });

                        history.push("/login");
                      }}
                    />
                  </div>
                ) : (
                  <div className="w--full">
                    <AppButton
                      title="Continue"
                      styles={{ width: "100%", marginTop: 16 }}
                      type="submit"
                      isLoading={isLoading}
                    />
                  </div>
                )}

                <div className="mt--16">
                  <Link
                    to="/login"
                    className="font--regular remove--anchorStyle"
                  >
                    Already have an account?{" "}
                    <span style={{ textDecoration: "underline" }}>Login</span>
                  </Link>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecoveryPage;
